/* 
  base class for modules, could be useful
*/

class Module {
  constructor() {
  }
  logData(logData) {
    logData.append(this.name, this.value);
  }
}

export default Module;